import { htmlSafe } from '@ember/template';
import { t } from 'i18n';
export function filterValuesLabel(values, totalValuesCount, filterName, enabledAtAllValues = false) {
  return htmlSafe(labelForFilterValueList(values.compact(), totalValuesCount, filterName, enabledAtAllValues));
}
function labelForFilterValueList(values, totalValuesCount, filterName, enabledAtAllValues) {
  if (enabledAtAllValues) {
    return t('filter.valueList.all', {
      filterName
    });
  }
  switch (values.length) {
    case 0:
      return t('filter.valueList.none', {
        filterName
      });
    case 1:
      return t('filter.valueList.one', {
        nickname1: values[0]
      });
    case 2:
      {
        const [nickname1, nickname2] = caseInsensitiveSorted(values);
        return t('filter.valueList.two', {
          nickname1,
          nickname2
        });
      }
    case totalValuesCount:
      return t('filter.valueList.all', {
        filterName
      });
    default:
      return t('filter.valueList.more', {
        count: values.length,
        filterName
      });
  }
}
function caseInsensitiveSorted(strings) {
  return strings.sort((a, b) => a.toLowerCase() < b.toLowerCase() ? -1 : 1);
}